import { render, staticRenderFns } from "./dispensation6.vue?vue&type=template&id=0d55a2be&scoped=true"
import script from "./dispensation6.vue?vue&type=script&lang=js"
export * from "./dispensation6.vue?vue&type=script&lang=js"
import style0 from "./dispensation6.vue?vue&type=style&index=0&id=0d55a2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d55a2be",
  null
  
)

export default component.exports